/* BOU: comportamiento de los componentes propios del tema.
 * - <bou-selector>: selector de packs "Llevá 1/2/3" con agregado opcional.
 * - [data-bou-agregar]: botones "+ Agregar" de un toque.
 * - .bou-despacho: calcula el próximo día de despacho (días y hora de corte en los ajustes del bloque).
 * - Carrito: barra "Te faltan $X para el envío gratis" y una sugerencia según lo que hay.
 * - Popup "Raspá y descubrí tu descuento" con suscripción por email.
 * Avisa al tema con el evento cart:update, igual que el formulario de producto de Horizon.
 */
(() => {
  const CFG = window.BOU || {};
  const UMBRAL = CFG.umbral || 5000000; // centavos
  const fmt = (c) => '$' + Math.round(c / 100).toLocaleString('es-AR');

  async function agregar(items, origen) {
    // Igual que el formulario de producto del tema: se piden las secciones del carrito en la misma llamada,
    // así el tema las redibuja antes de abrir el carrito lateral (si se redibujan después, lo cierran).
    const secciones = [...new Set([...document.querySelectorAll('cart-items-component')].map((e) => e.dataset.sectionId).filter(Boolean))];
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: secciones.join(','), sections_url: location.pathname }),
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || 'No se pudo agregar');
    const cart = await fetch('/cart.js').then((x) => x.json());
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId: origen, data: { itemCount: cart.item_count, source: origen, sections: data.sections } },
    }));
    actualizarCarrito(cart);
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') setTimeout(() => { drawer.open(); setTimeout(() => pintar(ultimoCarrito), 400); }, 120);
    else window.location.href = '/cart';
    return cart;
  }

  // ---------- Selector de packs ----------
  class BouSelector extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', () => this.marcar());
      this.querySelector('[data-bou-sel-btn]')?.addEventListener('click', (e) => { e.preventDefault(); this.enviar(); });
      this.marcar();
    }
    marcar() {
      this.querySelectorAll('.bou-sel__op').forEach((op) => op.classList.toggle('is-sel', !!op.querySelector('input[type=radio]')?.checked));
    }
    async enviar() {
      const btn = this.querySelector('[data-bou-sel-btn]');
      const err = this.querySelector('.bou-sel__error');
      const op = this.querySelector('.bou-sel__op.is-sel');
      if (!op) return;
      const variante = op.querySelector('.bou-sel__variante');
      const items = [{ id: Number(variante.value), quantity: Number(op.dataset.qty || 1) }];
      const agr = this.querySelector('[data-bou-agregado]');
      if (agr && agr.checked) items.push({ id: Number(agr.value), quantity: 1 });
      btn.disabled = true; const txt = btn.textContent; btn.textContent = 'Agregando…';
      if (err) err.hidden = true;
      try { await agregar(items, 'bou-selector'); }
      catch (e) { if (err) { err.textContent = e.message; err.hidden = false; } }
      finally { btn.disabled = false; btn.textContent = txt; }
    }
  }
  if (!customElements.get('bou-selector')) customElements.define('bou-selector', BouSelector);

  // ---------- Botones "+ Agregar" ----------
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-bou-agregar]');
    if (!b) return;
    e.preventDefault();
    const t = b.textContent; b.disabled = true; b.textContent = '…';
    try { await agregar([{ id: Number(b.dataset.bouAgregar), quantity: 1 }], 'bou-agregar'); b.textContent = '✓'; }
    catch (err) { b.textContent = 'Sin stock'; }
    setTimeout(() => { b.disabled = false; b.textContent = t; }, 1800);
  });

  // ---------- Próximo despacho ----------
  function despacho(el) {
    const dias = (el.dataset.dias || '1,3,5').split(',').map(Number);
    const corte = Number(el.dataset.corte || 12);
    // Hora de Buenos Aires (UTC-3, sin horario de verano)
    const ahora = new Date(Date.now() - 3 * 3600 * 1000);
    let d = new Date(ahora);
    let hoy = dias.includes(d.getUTCDay()) && d.getUTCHours() < corte;
    if (!hoy) {
      for (let i = 1; i < 8; i++) { d = new Date(ahora.getTime() + i * 86400000); if (dias.includes(d.getUTCDay())) break; }
    }
    const nombres = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    const dd = String(d.getUTCDate()).padStart(2, '0'), mm = String(d.getUTCMonth() + 1).padStart(2, '0');
    const manana = !hoy && (d.getTime() - ahora.getTime()) < 36 * 3600 * 1000 && d.getUTCDate() !== ahora.getUTCDate();
    const cuando = hoy ? 'hoy' : (manana ? `mañana ${dd}/${mm}` : `el ${nombres[d.getUTCDay()]} ${dd}/${mm}`);
    const t = el.querySelector('[data-bou-cuando]');
    if (t) t.textContent = cuando;
  }
  document.querySelectorAll('.bou-despacho').forEach(despacho);

  // ---------- Carrito: barra de envío gratis y sugerencia ----------
  let ultimoCarrito = CFG.carrito || null;
  function htmlBarra(total) {
    const falta = Math.max(0, UMBRAL - total);
    const pct = Math.min(100, Math.round((total / UMBRAL) * 100));
    const texto = falta > 0
      ? `Te faltan <strong>${fmt(falta)}</strong> para el <strong>envío gratis</strong> a sucursal`
      : '<strong>¡Tenés envío gratis a sucursal!</strong>';
    return `<div class="bou-barra" data-bou-barra><div>${texto}</div><div class="bou-barra__pista"><div class="bou-barra__relleno" style="width:${pct}%"></div></div></div>`;
  }
  function htmlSugerencia(cart) {
    const s = CFG.sugerencias || [];
    const handles = (cart.items || []).map((i) => i.handle);
    const sug = s.find((x) => x.si.some((h) => handles.includes(h)) && !handles.includes(x.handle));
    if (!sug) return '';
    return `<div class="bou-cart-up" data-bou-sug><img src="${sug.imagen}" alt="" width="44" height="44" loading="lazy"><div style="flex:1;min-width:0"><strong>${sug.titulo}</strong><br><span>${sug.texto}</span></div><button class="bou-agr__btn" data-bou-agregar="${sug.variante}">+ Agregar</button></div>`;
  }
  function pintar(cart) {
    if (!cart) return;
    const destinos = document.querySelectorAll('.cart-drawer__summary, .cart-summary');
    destinos.forEach((dest) => {
      if (dest.parentElement?.closest('.cart-drawer__summary, .cart-summary')) return; // evita duplicar si están anidados
      dest.querySelectorAll('[data-bou-barra],[data-bou-sug]').forEach((n) => n.remove());
      if (!cart.item_count) return;
      dest.insertAdjacentHTML('afterbegin', htmlSugerencia(cart) + htmlBarra(cart.total_price));
    });
  }
  function actualizarCarrito(cart) { ultimoCarrito = cart; pintar(cart); }
  async function refrescar() { try { actualizarCarrito(await fetch('/cart.js').then((r) => r.json())); } catch (_) {} }
  document.addEventListener('cart:update', (e) => { if (e.detail?.sourceId?.startsWith?.('bou-')) return; setTimeout(refrescar, 350); });
  document.addEventListener('discount:update', () => setTimeout(refrescar, 350));
  // El tema vuelve a dibujar el carrito con morph: si se borran la barra o la sugerencia, se repintan.
  const obs = new MutationObserver(() => {
    if (!ultimoCarrito) return;
    const falta = ultimoCarrito.item_count > 0 && [...document.querySelectorAll('.cart-drawer__summary, .cart-summary')]
      .some((d) => !d.parentElement?.closest('.cart-drawer__summary, .cart-summary') && !d.querySelector('[data-bou-barra]'));
    if (falta) { obs.disconnect(); pintar(ultimoCarrito); obs.observe(document.body, { childList: true, subtree: true }); }
  });
  obs.observe(document.body, { childList: true, subtree: true });
  if (ultimoCarrito) pintar(ultimoCarrito); else refrescar();

  // Formularios de suscripción (popup, pie, Club): se recuerda cuál se envió para mostrar la respuesta al volver.
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-bou-form]');
    if (f) try { sessionStorage.setItem('bou-form', f.dataset.bouForm); } catch (_) {}
  });

  // ---------- Popup "Raspá y descubrí tu descuento" ----------
  const pop = document.querySelector('[data-bou-pop]');
  if (pop) {
    const KEY = 'bou-pop-visto';
    let visto = false;
    try { visto = !!localStorage.getItem(KEY); } catch (_) {}
    const params = new URLSearchParams(location.search);
    let origen = null;
    try { origen = sessionStorage.getItem('bou-form'); sessionStorage.removeItem('bou-form'); } catch (_) {}
    const exito = params.get('customer_posted') === 'true' && (origen === 'pop' || origen === 'news');
    if (params.get('customer_posted') === 'true' && origen && origen.startsWith('club')) {
      document.querySelectorAll('[data-bou-club-ok]').forEach((n) => { n.hidden = false; n.scrollIntoView({ block: 'center' }); });
    }
    const abrir = () => { pop.classList.add('is-open'); try { localStorage.setItem(KEY, '1'); } catch (_) {} };
    pop.addEventListener('click', (e) => { if (e.target === pop || e.target.closest('[data-bou-pop-cerrar]')) pop.classList.remove('is-open'); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') pop.classList.remove('is-open'); });
    if (exito) { pop.dataset.paso = 'codigo'; abrir(); }
    else if (!visto && !/\/(cart|checkout|account)/.test(location.pathname)) setTimeout(abrir, Number(pop.dataset.demora || 9000));

    const canvas = pop.querySelector('canvas');
    if (canvas) {
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      const ini = () => {
        const w = canvas.offsetWidth || 260, h = canvas.offsetHeight || 110;
        canvas.width = w; canvas.height = h;
        ctx.fillStyle = '#c9c6bd'; ctx.fillRect(0, 0, w, h);
        ctx.fillStyle = '#6d6a62'; ctx.font = '700 18px Inter, Arial'; ctx.textAlign = 'center'; ctx.fillText('RASPÁ ACÁ', w / 2, h / 2 + 6);
        ctx.globalCompositeOperation = 'destination-out';
      };
      let raspando = false, listo = false;
      const raspar = (ev) => {
        if (!raspando || listo) return;
        const b = canvas.getBoundingClientRect();
        const p = ev.touches ? ev.touches[0] : ev;
        ctx.beginPath(); ctx.arc(p.clientX - b.left, p.clientY - b.top, 20, 0, Math.PI * 2); ctx.fill();
        const px = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        let vacios = 0; for (let i = 3; i < px.length; i += 16) if (px[i] === 0) vacios++;
        if (vacios / (px.length / 16) > 0.45) { listo = true; canvas.style.transition = 'opacity .4s'; canvas.style.opacity = '0'; pop.dataset.paso = 'email'; }
      };
      canvas.addEventListener('pointerdown', (e) => { raspando = true; raspar(e); });
      window.addEventListener('pointerup', () => { raspando = false; });
      canvas.addEventListener('pointermove', raspar);
      const io = new MutationObserver(() => { if (pop.classList.contains('is-open') && !canvas.dataset.ok) { canvas.dataset.ok = '1'; ini(); } });
      io.observe(pop, { attributes: true, attributeFilter: ['class'] });
      pop.querySelector('[data-bou-saltar]')?.addEventListener('click', () => { listo = true; canvas.style.opacity = '0'; pop.dataset.paso = 'email'; });
    }
    pop.querySelector('[data-bou-copiar]')?.addEventListener('click', async (e) => {
      try { await navigator.clipboard.writeText(e.currentTarget.dataset.bouCopiar); e.currentTarget.textContent = '¡Copiado!'; } catch (_) {}
    });
  }
})();

/* BOU v3 (estilo SMUD): anuncios que rotan, carruseles con barra de avance, aparición al bajar,
 * video de portada según el ancho y botón fijo "Añadir al carrito" en el celular. */
(() => {
  // ---------- Anuncios ----------
  document.querySelectorAll('[data-b3-anuncio]').forEach((bar) => {
    const msjs = [...bar.querySelectorAll('.b3-anuncio__msj')];
    if (msjs.length < 2) return;
    let i = 0, timer;
    const ir = (d) => { msjs[i].classList.remove('is-on'); i = (i + d + msjs.length) % msjs.length; msjs[i].classList.add('is-on'); };
    const auto = () => { clearInterval(timer); timer = setInterval(() => ir(1), 4500); };
    bar.querySelectorAll('.b3-anuncio__flecha').forEach((b) => b.addEventListener('click', () => { ir(Number(b.dataset.dir)); auto(); }));
    auto();
  });

  // ---------- Carruseles con barra de avance ----------
  document.querySelectorAll('[data-b3-carrusel]').forEach((car) => {
    const pista = car.querySelector('.b3-carrusel__pista');
    const barra = car.querySelector('.b3-barra');
    const pulgar = car.querySelector('.b3-barra__pulgar');
    if (!pista) return;
    const pintar = () => {
      const max = pista.scrollWidth - pista.clientWidth;
      car.classList.toggle('sin-scroll', max <= 2);
      if (!pulgar || !barra) return;
      const ancho = Math.max(0.12, pista.clientWidth / pista.scrollWidth);
      pulgar.style.width = (ancho * 100) + '%';
      pulgar.style.left = (max > 0 ? (pista.scrollLeft / max) * (1 - ancho) * 100 : 0) + '%';
    };
    pista.addEventListener('scroll', pintar, { passive: true });
    window.addEventListener('resize', pintar);
    pintar();
    // Tocar la barra lleva a esa parte del carrusel.
    barra?.addEventListener('click', (e) => {
      const r = barra.getBoundingClientRect();
      pista.scrollTo({ left: ((e.clientX - r.left) / r.width) * (pista.scrollWidth - pista.clientWidth), behavior: 'smooth' });
    });
    // Flechas (si las hay): avanzan de a una tarjeta.
    const paso = () => (pista.firstElementChild?.getBoundingClientRect().width || 300) + parseFloat(getComputedStyle(pista).columnGap || 16);
    car.querySelector('[data-b3-prev]')?.addEventListener('click', () => pista.scrollBy({ left: -paso(), behavior: 'smooth' }));
    car.querySelector('[data-b3-next]')?.addEventListener('click', () => pista.scrollBy({ left: paso(), behavior: 'smooth' }));
    // Arrastrar con el mouse en escritorio; sin bloquear los clics de las tarjetas.
    let x0 = 0, s0 = 0, movio = false, abajo = false;
    pista.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; abajo = true; movio = false; x0 = e.clientX; s0 = pista.scrollLeft; });
    window.addEventListener('pointermove', (e) => {
      if (!abajo) return;
      const dx = e.clientX - x0;
      if (Math.abs(dx) > 5) { movio = true; pista.classList.add('is-arrastrando'); }
      if (movio) pista.scrollLeft = s0 - dx;
    });
    window.addEventListener('pointerup', () => { if (!abajo) return; abajo = false; setTimeout(() => pista.classList.remove('is-arrastrando'), 0); });
    pista.addEventListener('click', (e) => { if (movio) { e.preventDefault(); e.stopPropagation(); movio = false; } }, true);
  });

  // ---------- Aparecer al bajar ----------
  const vistos = document.querySelectorAll('.b3-aparece');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    vistos.forEach((el) => io.observe(el));
  } else vistos.forEach((el) => el.classList.add('is-visible'));

  // ---------- Video de portada: vertical en el celular, horizontal en escritorio ----------
  document.querySelectorAll('[data-b3-video]').forEach((v) => {
    const mq = matchMedia('(min-width: 750px)');
    const poner = () => {
      const src = mq.matches ? v.dataset.escritorio : v.dataset.movil;
      if (!src || v.dataset.actual === src) return;
      v.dataset.actual = src; v.src = src;
      v.play?.().catch(() => {});
    };
    v.addEventListener('playing', () => v.classList.add('is-on'));
    mq.addEventListener?.('change', poner);
    poner();
  });

  // ---------- Botón fijo "Añadir al carrito" en el celular ----------
  const fijo = document.querySelector('[data-b3-fijo]');
  if (fijo) {
    const objetivo = () => document.querySelector('[data-bou-sel-btn]') || document.querySelector('product-form-component button[type="submit"], form[action*="/cart/add"] button[type="submit"]');
    const btn = objetivo();
    if (btn && 'IntersectionObserver' in window) {
      // Como en SMUD: está visible siempre que el botón principal no se vea en pantalla.
      new IntersectionObserver(([en]) => fijo.classList.toggle('is-on', !en.isIntersecting)).observe(btn);
      fijo.querySelector('button')?.addEventListener('click', () => { const b = objetivo(); if (b) b.click(); });
    }
  }
})();
